import Const from 'const';

export class LineupStackExtractor {
    protected stackedTeams: string[] = [];

    constructor(
        protected readonly lineup: string[],
        protected readonly marker,
    ) {
        this.extractStackedTeams();
    }

    public getStackedTeams(): string[] {
        return [...this.stackedTeams];
    }

    protected extractStackedTeams(): void {
        const markedItems = this.marker.pickMarkedBySuffix(this.lineup);

        const stackedTeams = {};
        markedItems.map((markedItem, index) => {
            if (markedItem[0] !== Const.LP_TEAM_GROUP_PREFIX) {
                return;
            }

            const [teamName, stackNumber = index] = markedItem
                .replace(Const.LP_TEAM_GROUP_PREFIX, '')
                .split(Const.LP_ITEM_DELIMITER);

            stackedTeams[stackNumber] = teamName;
        });

        this.stackedTeams = Object.values(stackedTeams);
    }
}
